import { Component, OnInit, OnDestroy, Renderer2, Input, ViewChild, ElementRef } from '@angular/core';
import { Message } from 'primeng/components/common/api';
import { FormGroup, FormControl, Validators, FormBuilder, FormArray } from '@angular/forms';
import { MenuItem, FileUpload } from 'primeng/primeng';
import { Router } from '@angular/router';
import { RegistrationService } from '../services/registration.service';
import { AdditionalData } from './AdditionalData';
import { MessageService } from 'primeng/components/common/messageservice';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
//import { ConfirmationService } from 'primeng/api';

@Component({
    selector: 'app-new-admin-panel',
    templateUrl: './new-admin-panel.component.html',
    styleUrls: ['./new-admin-panel.component.scss']
})
export class NewAdminPanelComponent implements OnInit {
    msgs: Message[] = [];
    info: Message[] = [];
    accept: boolean = false;
    donotaccept: boolean = false;
    copyaddress: boolean = false;
    //msgsuccess: Message[] = [];
    generalInformationForm: FormGroup;
    minDateOfBirth: Date;
    maxDateOfBirth: Date;
    dateOfBirth: Date;
    maxDateOfBirthYear: number;
    minDateOfBirthYear: number;
    dataList: any;
    boardName: any;
    cdt: any;
    fm: any;
    tm: any;
    dbm: any;
    dby: any;
    displayForm: boolean = false;
    public genderList = [];
    public genericList = [];
    public categoryList = [];
    public postcategoryList = [];
    public departList = [];
    public distList = [];
    public phycalHList = [];
    public postlist = [];
    public subjectSPLList = [];
    public boardList = [];
    public examList = [];
    public yearList = [];
    public emailPattern = "^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$";
    public expList = [];
    public acaList = [];
    public staffDetailsInfo = [];
    public typeofEmplpyment = [];
    public nationalitylist = [];
    public religionlist = [];
    public maritalstatuslist = [];
    public chkdept = [];
    scrollHeight: string = '400px';
    distName: any;
    academicdetailList: any;
    acaDetailsInfo: {
        academicyr: any,
        edudetail: any,
        exampass: any,
        id: any,
        parent_id: any,
        marks: any,
        subjectstudied: any,
        otherinfo: any,
        division: any,
        certificate: any,
        certificatename: any
    }[];
    expDetailsInfo: {
        id: any,
        parent_id: any,
        instituteName: any,
        yearcount: any,
        typeofemployee: any,
        designation: any,
        payscale: any,
        remarks: any,
    }[];
    rowData: any;
    processbar: boolean = false;
    user_id: any;
    designationId: any;
    postcategoryid: any;
    departmentId: any;
    showdeleteBtn: boolean = false;
    advid: any;
    advName: any;
    showdept: boolean = false;
    public typeofInstList = [];
    fileToUpload: File = null;
    uploadUrl: string;
    uploadedFiles: any[] = [];
    input = new FormData();
    advt: any;
    public advtList = [];
    forpayment: boolean = false;
    paymentmsg: any;
    disablesubmit: boolean = false;
    shownocCertificate: boolean = false;
    showcastecertificate: boolean = false;
    showphcertificate: boolean = false;
    showpdfdialog: boolean = false;
    pdflink: any;
    previouslyapplied: boolean = false
    showbankdetails: boolean = false;
    displayConfirmation = false;
    confirmmsg: any;
    userdtetails: any;
    chkusertyp: boolean = false;
    showprintForm: boolean = false;
    showprintFormChallan: boolean = false;
    certlist: any;
    photolink: any;
    signlink: any;
    doblink: any;
    castelink: any;
    phlink: any;
    presentemployerlink: any;
    duplicatepdflink: any;
    duplicatechallanlink: any;
    showformlink: boolean = false;
    certlinks = [];
    show: boolean;
    hideoldbankdetails: boolean = false;
    advname: any;
    departmentFlag: boolean = false;
    did: any;
    chkdeptStore: any;
    chkPostFlag: boolean = false;
    constructor(private registrationService: RegistrationService, private router: Router) { }

    @Input() additionaldata: AdditionalData;
    @ViewChild('form') form: ElementRef;

    ngOnInit() {
        this.user_id = localStorage.getItem('member-id');
        this.advName = localStorage.getItem('advName');
        this.typeofInstList = [
            {
                'id': 'College',
                'name': 'College'
            },
            {
                'id': 'University',
                'name': 'University'
            },
            {
                'id': 'Institute',
                'name': 'Institute'
            }
        ]
        this.maritalstatuslist = [
            {
                'id': 'Single',
                'name': 'Single'
            }, {
                'id': 'Married',
                'name': 'Married'
            }
        ]
        this.genderList = [
            {
                'id': 'Male',
                'name': 'Male'
            }, {
                'id': 'Female',
                'name': 'Female'
            }, {
                'id': 'Third Gender',
                'name': 'Third Gender'
            }
        ];

        this.genericList = [
            {
                'id': 'NO',
                'name': 'NO'
            }, {
                'id': 'YES',
                'name': 'YES'
            }
        ];
        this.typeofEmplpyment = [
            {
                'id': 'PERMANENT',
                'name': 'PERMANENT'
            }, {
                'id': 'CONTRACTUAL',
                'name': 'CONTRACTUAL'
            }, {
                'id': 'GUEST LECTURER',
                'name': 'GUEST LECTURER'
            }
            , {
                'id': 'PART TIME',
                'name': 'PART TIME'
            }
        ];
        this.additionaldata = new AdditionalData;
        this.additionaldata.academicData = [
            {
                academicyr: 0,
                edudetail: 0,
                exampass: 0,
                id: '',
                parent_id: '',
                marks: '',
                subjectstudied: '',
                otherinfo: '',
                division: '',
                certificate: '',
                certificatename: ''
            }
        ];
        this.additionaldata.experienceData = [
            {
                id: '',
                parent_id: '',
                instituteName: '',
                yearcount: '',
                typeofemployee: 0,
                designation: '',
                payscale: '',
                remarks: '',
            }
        ];
        this.advid = localStorage.getItem('advId');
        this.advName = localStorage.getItem('advName');
        this.getAllCommonList();
        this.getAllCandidateList();
    }

    getPrintCommonList() {
        this.designationId = 0;
        this.postcategoryid = 0;
        this.departmentId = 0;
        this.registrationService.getCommonList(this.advid).then(res => {
            this.dataList = res;
            this.postcategoryList = this.dataList.postcategoryList;
            if (this.advid != 5)
                this.departList = this.dataList.departList;
            this.postlist = this.dataList.postlist;
        });
    }
    getAllCandidateList() {
        this.processbar = true;
        let id = localStorage.getItem('member-id');
        this.registrationService.getAllCandidateList(id, this.advid).then(res => {
            this.dataList = res;
            this.staffDetailsInfo = this.dataList.allStaffDetails;
            this.processbar = false;
        });
        this.getPrintCommonList();
        this.getAllCommonList();
    }

    getAllCommonList() {
        this.processbar = true;
        // console.log('getAllCommonList==================');
        if (this.advid == 4) {
            this.hideoldbankdetails = true;
        }
        else if (this.advid == 5) {
            this.hideoldbankdetails = false;
        }
        this.advName = localStorage.getItem('advName');
        this.registrationService.getCommonList(this.advid).then(res => {
            this.processbar = false;
            this.dataList = res;
            this.chkdeptStore = this.dataList.chkdept;
            // console.log(this.dataList); // check by Atanu
            this.categoryList = this.dataList.categoryList;
            this.postcategoryList = this.dataList.postcategoryList;
            if (this.advid != 5)
                this.departList = this.dataList.departList;
            if (this.dataList.chkdept == 1) //add by JD
               this.departmentFlag = true;
            if(this.dataList.chkpost == 1)
               this.chkPostFlag = true;   
            this.distList = this.dataList.distList;
            this.phycalHList = this.dataList.phycalHList;
            this.postlist = this.dataList.postlist;
            this.subjectSPLList = this.dataList.subjectSPLList;
            this.boardList = this.dataList.boardList;
            this.examList = this.dataList.examList;
            this.yearList = this.dataList.yearList;
            this.nationalitylist = this.dataList.nationalitylist;
            this.religionlist = this.dataList.religionlist;
            this.yearList.push({ id: '-1', name: 'Select' });

            if (!localStorage.getItem('userdtls')) {
                this.additionaldata.designationId = 0;
                this.additionaldata.postcategoryid = 0;
                this.additionaldata.departmentId = 0;
                this.additionaldata.sex = 0;
                this.additionaldata.categoryId = 0;
                this.additionaldata.phid = 0;
                this.additionaldata.distId = 0;
                this.additionaldata.presentlyemployed = 0;
                this.additionaldata.nationalityid = 0;
                this.additionaldata.religionid = 0;
                this.additionaldata.maritalstatus = 0;
                this.additionaldata.disciplinary = 0;
                let acadata = [];
                acadata = this.additionaldata.academicData;

                for (let i = 0; i < this.examList.length; i++) {
                    this.acaAddRows();
                    acadata[i].exampass = this.examList[i].id;
                }
                this.additionaldata.academicData.splice(this.additionaldata.academicData.length - 1, 1);
            }
        }, error => {
            this.processbar = false;
        });
    }
    acaAddRows() {
        const newRow = {
            academicyr: '0',
            edudetail: 0,
            exampass: 0,
            id: '',
            parent_id: '',
            marks: '',
            subjectstudied: '',
            otherinfo: '',
            division: '',
            certificate: '',
            certificatename: ''
        };
        this.additionaldata.academicData.push(newRow);
    }
    expAddRows() {
        const newRow = {
            id: '',
            parent_id: '',
            //fromdate: '',
            //todate: '',
            instituteName: '',
            yearcount: '',
            typeofemployee: '0',
            //monthcount: '',
            designation: '',
            //institutetype:'',
            payscale: '',
            remarks: '',
            //presentemployer:''
        };
        this.additionaldata.experienceData.push(newRow);
    }

    reset() {
        // this.getAllCommonList();
        this.additionaldata.id = null;
        this.additionaldata.name = null;
        this.additionaldata.email = null;
        this.additionaldata.dob = null;
        this.additionaldata.mobile = null;
        this.additionaldata.sex = null;
        this.additionaldata.address = null;
        this.additionaldata.distId = null;
        this.additionaldata.pin = null;
        this.additionaldata.designationId = null;
        this.additionaldata.departmentId = null;
        this.additionaldata.categoryId = null;
        this.additionaldata.phid = null;
        this.additionaldata.publjrnlno = null;
        this.additionaldata.publbooksno = null;
        this.additionaldata.publprocedingno = null;
        this.additionaldata.attndseminerno = null;
        this.additionaldata.attndconfno = null;
        this.additionaldata.attndworkshopno = null;
        this.additionaldata.phdguideno = null;
        this.additionaldata.researchprojno = null;
        this.additionaldata.apiscore = null;
        this.additionaldata.applicationNo = null;
        this.additionaldata.academicData = [];
        this.additionaldata.experienceData = [];
        this.additionaldata.userid = null;
        this.additionaldata.postcategoryid = null;
        this.additionaldata.draftdate = null;
        this.additionaldata.oldbankdeaftno = null;
        this.additionaldata.drwanbank = null;
        this.additionaldata.drwanamount = null;

        this.additionaldata.phdthesisname = null;
        this.additionaldata.phdthesissubmitdate = null;
        this.additionaldata.phduniversity = null;
        this.additionaldata.publpeerjrnlno = null;
        this.additionaldata.publjrnlugcno = null;
        this.additionaldata.attndnationalseminerno = null;
        this.additionaldata.attndinternationalseminerno = null;
        this.additionaldata.awardstate = null;
        this.additionaldata.awardinternational = null;
        this.additionaldata.disciplinary = null;
        this.additionaldata.disciplinarydtls = null;
        this.additionaldata.researchno = null;
        this.additionaldata.researcharea = null;
        this.additionaldata.researchplaces = null;
        this.additionaldata.mphilresearchguidence = null;
        this.additionaldata.phdilresearchguidence = null;
        this.additionaldata.noticeperiod = null;
        this.additionaldata.mailingaddress = null;
        this.additionaldata.mailingpin = null;
        this.additionaldata.mailingdistId = null;
        this.additionaldata.permanentaddress = null;
        this.additionaldata.permanentpin = null;
        this.additionaldata.permanentdistId = null;
        this.additionaldata.fathername = null;
        this.additionaldata.mothername = null;
        this.additionaldata.nationalityid = null;
        this.additionaldata.religionid = null;
        this.additionaldata.maritalstatus = null;
        this.additionaldata.password = null;
        this.additionaldata.totalexperience = null;
        this.additionaldata.presentlyemployed = null;
        this.additionaldata.photo = null;
        this.additionaldata.sign = null;
        this.additionaldata.dateofbirthcertificate = null;
        this.additionaldata.castecertificate = null;
        this.additionaldata.phcertificate = null;
        this.additionaldata.currentemployercertificate = null;

        this.photolink = '';
        this.signlink = '';
        this.doblink = '';
        this.castelink = '';
        this.phlink = '';
        this.presentemployerlink = '';
        this.duplicatechallanlink = '';
        this.duplicatepdflink = '';
        this.certlinks = [];
    }

    removeExp(index, id) {
        if (id == '') {
            this.additionaldata.experienceData.splice(index, 1);
        } else {
            this.registrationService.deleteExperienceByid(id).then(res => {
                this.additionaldata.experienceData.splice(index, 1);
                this.dataList = res;
            }, error => {
                this.processbar = false;
            });
        }
    }

    validateEmail(email) {
        var re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return re.test(email);
    }

    myUploader(event, flg): void {
        this.processbar = true;
        if (event.files.length == 0) {

            return;
        }
        this.input = new FormData();
        var fileToUpload = event.files[0];
        this.input.append("file", fileToUpload);
        let expdata = [];
        expdata = this.additionaldata.experienceData;
        this.registrationService.docupload(this.input, flg).then(res => {
            this.dataList = res;

            if (this.dataList.status == 'success') {
                this.processbar = false;
                if (this.dataList.flg == 'dob') {
                    this.additionaldata.dateofbirthcertificate = this.dataList.file;
                    this.msgs = [];
                    this.msgs.push({ severity: 'success', summary: 'Success Message', detail: this.dataList.message });
                }
                else if (this.dataList.flg == 'caste') {
                    this.additionaldata.castecertificate = this.dataList.file;
                    this.msgs = [];
                    this.msgs.push({ severity: 'success', summary: 'Success Message', detail: this.dataList.message });
                }
                else if (this.dataList.flg == 'photo') {
                    this.additionaldata.photo = this.dataList.file;
                    this.msgs = [];
                    this.msgs.push({ severity: 'success', summary: 'Success Message', detail: this.dataList.message });
                }
                else if (this.dataList.flg == 'sign') {
                    this.additionaldata.sign = this.dataList.file;
                    this.msgs = [];
                    this.msgs.push({ severity: 'success', summary: 'Success Message', detail: this.dataList.message });
                }
                else if (this.dataList.flg == 'ph') {
                    this.additionaldata.phcertificate = this.dataList.file;
                    this.msgs = [];
                    this.msgs.push({ severity: 'success', summary: 'Success Message', detail: this.dataList.message });
                }
                else if (this.dataList.flg == 'presentemployer') {
                    this.additionaldata.currentemployercertificate = this.dataList.file;
                    this.msgs = [];
                    this.msgs.push({ severity: 'success', summary: 'Success Message', detail: this.dataList.message });
                }
            }

        }, error => {
            this.processbar = false;
        })
    }

    onUpload(event): void {
        //console.log("onUpload");
        for (const file of event.files) {
            this.uploadedFiles.push(file);
        }

    }

    onBeforeSend(event): void {
        //console.log("onBeforeSend");
        //event.xhr.setRequestHeader('Authorization', 'Bearer ' + abp.auth.getToken());
    }

    handleAccept(e) {
        if (e) {
            this.disablesubmit = true;
            this.donotaccept = false
        } else {
            this.disablesubmit = false;
        }
    }

    handleDonotAccept(e) {
        if (e) {
            this.accept = false;
            this.disablesubmit = false;
        }
    }

    presentlemployer() {
        if (this.additionaldata.presentlyemployed === 'YES') {
            this.shownocCertificate = true;
        }
        else {
            this.shownocCertificate = false;
        }
    }

    setpermanentAddress(e) {
        if (e) {
            this.additionaldata.permanentaddress = this.additionaldata.mailingaddress;
            this.additionaldata.permanentpin = this.additionaldata.mailingpin;
        }
        else {
            this.additionaldata.permanentaddress = '';
            this.additionaldata.permanentpin = '';
        }
    }

    showCastecert() {
        //1,0
        if (this.additionaldata.categoryId == 1 || this.additionaldata.categoryId == 0) {
            this.showcastecertificate = false;
        }
        else {
            this.showcastecertificate = true;
        }
    }

    showPhcert() {
        //29,0
        if (this.additionaldata.phid == 29 || this.additionaldata.phid == 0) {
            this.showphcertificate = false;
        }
        else {
            this.showphcertificate = true;
        }
    }

    myUploaderAcademics(event, index) {
        let flg = index;
        this.processbar = true;
        if (event.files.length == 0) {
            console.log('No file selected.');
            return;
        }
        this.input = new FormData();
        var fileToUpload = event.files[0];
        this.input.append("file", fileToUpload);

        let acadata = [];
        acadata = this.additionaldata.academicData;

        this.registrationService.docuploadacademics(this.input, flg).then(res => {
            this.dataList = res;

            if (this.dataList.status == 'success') {
                this.processbar = false;
                acadata[index].certificate = this.dataList.file;
                this.msgs = [];
                this.msgs.push({ severity: 'success', summary: 'Success Message', detail: this.dataList.message });
            }
        }, error => {
            this.processbar = false;
        })
    }

    openbankdetails() {
        if (this.previouslyapplied) {
            this.showbankdetails = true;
        }
        else {
            this.showbankdetails = false;
        }
    }

    password() {
        this.show = !this.show;
    }

    onRowSelect(event) {
        // this.reset();
        this.showformlink = false;
        this.user_id = localStorage.getItem('member-id');
        this.displayForm = true;
        this.showdeleteBtn = true;
        this.rowData = this.cloneRecForm(event.data);
        this.processbar = true;
        this.additionaldata.id = this.rowData.id;
        this.registrationService.getStaffDetails(this.rowData.id).then(res => {
            // console.log(res);
            this.dataList = res;
            this.processbar = false;
            this.showprintForm = true;
            this.showprintFormChallan = true;
            this.additionaldata = this.dataList.recrutmentDtls;

            this.additionaldata.password = this.dataList.recrutmentDtls.passworddtls;
            let d1, d2, d3;
            if (this.dataList.recrutmentDtls.dob != null) {
                d1 = new Date(Date.parse(this.dataList.recrutmentDtls.dob));
                this.additionaldata.dob = d1.getDate() + '/' + (d1.getMonth() + 1) + '/' + d1.getFullYear();
            }

            if (this.dataList.recrutmentDtls.phdthesissubmitdate != null) {
                d3 = new Date(Date.parse(this.dataList.recrutmentDtls.phdthesissubmitdate));
                this.additionaldata.phdthesissubmitdate = d3.getDate() + '/' + (d3.getMonth() + 1) + '/' + d3.getFullYear();
            }

            if (this.dataList.recrutmentDtls.oldbankdeaftno != null) {
                this.previouslyapplied = true;
                this.showbankdetails = true;
                d2 = new Date(Date.parse(this.dataList.recrutmentDtls.draftdate));
                this.additionaldata.draftdate = d2.getDate() + '/' + (d2.getMonth() + 1) + '/' + d2.getFullYear();
            }

            this.photolink = this.dataList.photo;
            this.signlink = this.dataList.sign;
            this.doblink = this.dataList.dob;
            this.castelink = this.dataList.caste;
            this.phlink = this.dataList.ph;
            this.presentemployerlink = this.dataList.presentemployer;

            if (this.dataList.challanLink != '-') {
                this.showformlink = true;
                this.duplicatechallanlink = this.dataList.challanLink;
            }
            if (this.dataList.admitsLink != '-') {
                this.showformlink = true;
                this.duplicatepdflink = this.dataList.admitsLink;
            }

            this.certlinks = this.dataList.acacertlinks;
            let acadata = [];
            this.acaDetailsInfo = [];
            acadata = this.additionaldata.academicData.sort((a, b) => a.id - b.id);
            for (let i = 0; i < acadata.length; i++) {
                acadata[i].certificatename = this.certlinks[i].name;
            }

            this.presentlemployer();
            this.showCastecert();
            this.showPhcert();

        });
    }

    cloneRecForm(c: FormGroup): FormGroup {
        return c;
    }

    printCandidateListByPostAll() {
        if (this.designationId.id == undefined) {
            this.msgs = [];
            this.msgs.push({ severity: 'error', summary: 'Error Message', detail: 'Select Post' });
            return false;
        }
        // if (this.advid != 5) {
        // 	if (this.departmentId.id == undefined) {
        // 		this.msgs = [];
        // 		this.msgs.push({ severity: 'error', summary: 'Error Message', detail: 'Select Department' });
        // 		return false;
        // 	}
        // }
        if (this.postcategoryid.id == undefined) {
            this.msgs = [];
            this.msgs.push({ severity: 'error', summary: 'Error Message', detail: 'Select Post Category' });
            return false;
        }
        let data = {
            pid: this.designationId.id,
            pcid: this.postcategoryid.id,
            did: this.departmentId.id,
            pname: this.designationId.name,
            pcname: this.postcategoryid.name,
            dname: this.departmentId.name,
            userid: localStorage.getItem('member-id')
        }
        if (confirm("Do you want to Print?")) {
            this.processbar = true;
            this.registrationService.printCandidateListByPost(data, this.advid).then(res => {
                this.dataList = res;
                if (this.dataList.status == 'success') {
                    window.open(this.dataList.staffRecPdflink);
                } else {
                    alert("Data not found");
                }
                this.processbar = false;
            });
        }
    }

    printbiodata(flg) {
        // console.log(this.designationId);
        if (this.designationId.id == undefined) {
            this.msgs = [];
            this.msgs.push({ severity: 'error', summary: 'Error Message', detail: 'Select Post' });
            return false;
        }
        // if (this.advid != 5) {
        // 	if (this.departmentId.id == undefined) {
        // 		this.msgs = [];
        // 		this.msgs.push({ severity: 'error', summary: 'Error Message', detail: 'Select Department' });
        // 		return false;
        // 	}
        // }
        if (this.postcategoryid.id == undefined) {
            this.msgs = [];
            this.msgs.push({ severity: 'error', summary: 'Error Message', detail: 'Select Post Category' });
            return false;
        }
        let data = {
            pid: this.designationId.id,
            pcid: this.postcategoryid.id,
            did: this.departmentId.id,
            pname: this.designationId.name,
            pcname: this.postcategoryid.name,
            dname: this.departmentId.name,
            userid: localStorage.getItem('member-id')
        }
        if (confirm("Do you want to Print?")) {
            this.processbar = true;
            this.registrationService.printForm(data, flg, this.advid).then(res => {
                this.dataList = res;
                if (this.dataList.status == 'success') {
                    window.open(this.dataList.staffRecPdflink);
                } else {
                    alert("Data not found");
                }
                this.processbar = false;
            });
        }
    }

    printscoresheet(flg) {
        if (this.designationId.id == undefined) {
            this.msgs = [];
            this.msgs.push({ severity: 'error', summary: 'Error Message', detail: 'Select Post' });
            return false;
        }
        // if (this.advid != 5) {
        // 	if (this.departmentId.id == undefined) {
        // 		this.msgs = [];
        // 		this.msgs.push({ severity: 'error', summary: 'Error Message', detail: 'Select Department' });
        // 		return false;
        // 	}
        // }
        if (this.postcategoryid.id == undefined) {
            this.msgs = [];
            this.msgs.push({ severity: 'error', summary: 'Error Message', detail: 'Select Post Category' });
            return false;
        }
        let data = {
            pid: this.designationId.id,
            pcid: this.postcategoryid.id,
            did: this.departmentId.id,
            pname: this.designationId.name,
            pcname: this.postcategoryid.name,
            dname: this.departmentId.name,
            userid: localStorage.getItem('member-id')
        }
        if (confirm("Do you want to Print?")) {
            this.processbar = true;
            this.registrationService.printscoresheet(data, flg, this.advid).then(res => {
                // console.log(res);
                this.dataList = res;
                if (this.dataList.status == 'success') {
                    window.open(this.dataList.staffRecPdflink);
                } else {
                    alert("Data not found");
                }
                this.processbar = false;
            });
        }
    }

    // -----------------------------Add Latest------------------------------------
    printAplFrmBlk() {
        if (this.designationId.id == undefined) {
            this.msgs = [];
            this.msgs.push({ severity: 'error', summary: 'Error Message', detail: 'Select Post' });
            return false;
        }
        // if (this.advid != 5) {
        // 	if (this.departmentId.id == undefined) {
        // 		this.msgs = [];
        // 		this.msgs.push({ severity: 'error', summary: 'Error Message', detail: 'Select Department' });
        // 		return false;
        // 	}
        // }
        if (this.postcategoryid.id == undefined) {
            this.msgs = [];
            this.msgs.push({ severity: 'error', summary: 'Error Message', detail: 'Select Post Category' });
            return false;
        }

        if(this.departmentFlag = false){ // add by JD
            this.did = 0;
        }else{
            this.did = this.departmentId.id;
        }
        let data = {
            pid: this.designationId.id,
            pcid: this.postcategoryid.id,
            did: this.did,
            // pname: this.designationId.name,
            // pcname: this.postcategoryid.name,
            // dname: this.departmentId.name,
            // userid: localStorage.getItem('member-id')
        }
        if (confirm("Do you want to Print?")) {
            this.processbar = true;
            this.registrationService.printallapplform(this.advid, data.pid, data.pcid).then(res => {
                // console.log("ApplBulk",res);
                this.dataList = res;
                if (this.dataList.status == 'success') {

                    window.open(this.dataList.admitsLink);
                } else {
                    alert("Data not found");
                }
                this.processbar = false;
                if(this.chkdeptStore == 1)
                  this.departmentFlag = true;
            });
        }
    }
    // -----------------------------End Add Latest--------------------------------

}



// WEBPACK FOOTER //
// ./src/app/new-admin-panel/new-admin-panel.component.ts